'use strict';

export default angular
  .module('maestro.directives.common.autofocus', [])

  .directive('autofocus', function($timeout) {
    return {
      restrict: 'AC',
      link: function(scope, element, attr) {
        if (attr.autofocus === true || attr.autofocus === '') {
          $timeout(() => {
            element[0].focus();
          }, 0);
        } else if (attr.autofocus !== false) {
          scope.$watch(attr.autofocus, (newValue, oldValue) => {
            if (newValue && newValue !== oldValue) {
              $timeout(() => {
                element[0].focus();
              }, 0);
            }
          });
        }
      }
    };
  })

  .name;
